<template>
  <header class="row pt-1 md:pt-3 mb-3 md:mb-4 justify-between items-center">
    <div class="col lg:col-9 pt-3">
      <h2 class="h3 mb-0 flex items-center">
        <!-- Number -->
        <span class="inline-block lg:hidden mr-n6 relative self-start">
          <span class="text-lg absolute centered leading-1">
            {{ currentStep }}
          </span>
          <span class="block p-4 bg-primary rounded-circle opacity-10" />
        </span>
        <!-- Text -->
        <span class="px-7 lg:px-0 mx-auto lg:mx-0">{{ heading }}</span>
      </h2>
    </div>
    <!-- Favorite, display type -->
    <div class="hidden lg:flex col-4 lg:col-3 pt-3 items-center justify-end">
      <div class="flex bg-light rounded-pill">
        <!-- buttons -->
        <slot />
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },

  currentStep: {
    type: String,
    required: true,
    default: '1',
  },
})

const { t } = useI18n()

const heading = ref('')

const stepHeading = () => {
  switch (props.name) {
    case 'musli_base': {
      heading.value = t('musli_base')
      break
    }
    case 'musli_base_extended': {
      heading.value = t('musli_base_extended')
      break
    }
    case 'porridge_base': {
      heading.value = t('porridge_base')
      break
    }
    case 'dry_fruits': {
      heading.value = t('dry_fruits')
      break
    }
    case 'crunchy_fruits': {
      heading.value = t('crunchy_fruits')
      break
    }
    case 'nuts': {
      heading.value = t('nuts')
      break
    }
    case 'mixit_bars': {
      heading.value = t('mixit_bars')
      break
    }
    case 'fruit_bags': {
      heading.value = t('fruit_bags')
      break
    }
    case 'on_top': {
      heading.value = t('on_top_category')
      break
    }
    default:
    // do nothing
  }
}

stepHeading()
</script>

<i18n>
  {
    "cs": {
    "crunchy_fruits": "Křupavé ovoce",
    "dry_fruits": "Sušené ovoce",
    "fruit_bags": "Pytlíky do kapsy",
    "mixit_bars": "Mixitky",
    "musli_base": "Müsli základ",
    "musli_base_extended": "Rozšíření základu",
    "nuts": "Ořechy",
    "on_top_category": "Čoko & spol.",
    "porridge_base": "Základ kaše"
},
    "sk": {
    "crunchy_fruits": "Chrumkavé ovocie",
    "dry_fruits": "Sušené ovocie",
    "fruit_bags": "Vrecúška do vrecka",
    "mixit_bars": "Mixitky",
    "musli_base": "Müsli základ",
    "musli_base_extended": "Rozšírenie základu",
    "nuts": "Orechy",
    "on_top_category": "Čoko & spol.",
    "porridge_base": "Základ kaše"
},
    "pl": {
    "crunchy_fruits": "Chrupiące owoce",
    "dry_fruits": "Suszone owoce",
    "fruit_bags": "Saszetki do kieszeni",
    "mixit_bars": "Mixitki",
    "musli_base": "Podstawa müsli",
    "musli_base_extended": "Rozszerzenie podstawy",
    "nuts": "Orzechy",
    "on_top_category": "Czekolada & dodatki",
    "porridge_base": "Podstawa kaszy"
},
    "hu": {
    "crunchy_fruits": "Ropogós gyümölcsök",
    "dry_fruits": "Szárított gyümölcs",
    "fruit_bags": "Zsebbe való tasakok",
    "mixit_bars": "Mixitkák",
    "musli_base": "Müzli alap",
    "musli_base_extended": "Müzlialap kibővítése",
    "nuts": "Diófélék",
    "on_top_category": "Csoki & társai",
    "porridge_base": "Kása alap"
},
    "de": {
    "crunchy_fruits": "Knusperfrüchte",
    "dry_fruits": "Trockenfrüchte",
    "fruit_bags": "Snacktaschen",
    "mixit_bars": "Mixitriegel",
    "musli_base": "Müslibasis",
    "musli_base_extended": "Erweiterung der Basis",
    "nuts": "Nüsse",
    "on_top_category": "Schoko & Co.",
    "porridge_base": "Breibasis"
},
    "at": {
    "crunchy_fruits": "Knusperfrüchte",
    "dry_fruits": "Trockenfrüchte",
    "fruit_bags": "Snacktaschen",
    "mixit_bars": "Mixitriegel",
    "musli_base": "Müslibasis",
    "musli_base_extended": "Erweiterung der Basis",
    "nuts": "Nüsse",
    "on_top_category": "Schoko & Co.",
    "porridge_base": "Breibasis"
},
    "ro": {
    "crunchy_fruits": "Fructe crocante",
    "dry_fruits": "Fructe uscate",
    "fruit_bags": "Punguțe",
    "mixit_bars": "Mixitka",
    "musli_base": "Musli bază",
    "musli_base_extended": "Completează baza",
    "nuts": "Nuci",
    "on_top_category": "Cioco & co.",
    "porridge_base": "Terci bază"
},
    "fr": {
    "crunchy_fruits": "Fruits croustillants",
    "dry_fruits": "Fruits secs",
    "fruit_bags": "Format poche",
    "mixit_bars": "Mixitka",
    "musli_base": "Base de muesli",
    "musli_base_extended": "Base enrichie",
    "nuts": "Fruits à coque",
    "on_top_category": "Choco et compagnie",
    "porridge_base": "Base du porridge"
}
  }
</i18n>
